import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as action from '../../redux/actions';
import mastercardlogo from '../../img/openpay/masterCard.png';
import visalogo from '../../img/openpay/visa.png';
import americanlogo from '../../img/openpay/americanExpress.png';
import Button from '../button';

export class ModalSolicitarPedido extends Component {
   _isMounted = false;

   constructor(props) {
      super(props);
      this.state = {
         loading: false,
         loading_text: '',
         Message: '',
         view: 'direction',
         cartIcon: '',
         showOrderConfirmation: false,
      };
   }

   componentDidMount() {
      this._isMounted = true;
   }

   componentWillUnmount() {
      this._isMounted = false;
   }

   checkout() {
      const data = this.props.carrito;
      if (!this.props.auth) {
         this.setState({ Message: 'No se ha iniciado sesion' });
         return;
      }
      if (data.length > 0 && this.props.auth) {
         this.props.dispatch(action.checkPrices(data));
         this.setState({ loading_text: 'VALIDANDO LOS PRECIOS CORRECTOS' });
      }
   }

   cardChange(event) {
      const type = window.OpenPay.card.cardType(event.target.value);
      console.log(type);
      let clase = '';
      if (type.indexOf('Visa') !== -1) {
         clase = 'fab fa-cc-visa';
      }
      if (type.indexOf('Mastercard') !== -1) {
         clase = 'fab fa-cc-mastercard';
      }
      if (type.indexOf('American Express') !== -1) {
         clase = 'fab fa-cc-amex';
      }
      if (type.indexOf('Diners') !== -1) {
         clase = 'fab fa-cc-diners-club';
      }
      if (type.indexOf('Discover') !== -1) {
         clase = 'fab fa-cc-discover';
      }
      if (type.indexOf('JCB') !== -1) {
         clase = 'fab fa-cc-jcb';
      }
      this.setState({ cardIcon: <i className={clase} /> });
   }

   async handleAdd(event) {
      event.preventDefault();
      var direction = {
         name: event.target.name.value,
         last_name: event.target.last_name.value,
         address: event.target.address.value,
         city: event.target.city.value,
         zip_code: event.target.zip.value,
         phone: event.target.phone.value,
         email: event.target.email.value,
         state: event.target.state.value,
      };
      // guardamos dirección solo si está logueado
      if (this.props.auth) {
         this.props.dispatch(action.save_Direction(direction));
      }
      this.setState({ loading: true });
      const data = {
         direction,
         user: this.props.auth ? this.props.user : { IdCliente: 0 },
         cart: this.props.carrito,
         comentarios: document.getElementById('checkout-comment').value,
      };
      const result = await action.generarPedido(data);
      if (result && result.data && result.data.Folio)
         this.props.onNext(result.data.Folio, data.direction.email);
      if (this._isMounted) {
         this.setState({ loading: false });
      }
   }

   pagar(event) {
      event.preventDefault();
      const form = event.target;
      // reset classlist
      form.holder_name.classList.add('input-text');
      form.card_number.classList.add('input-text');
      form.cvc.classList.add('input-text');
      form.month.classList.add('input-text');
      form.year.classList.add('input-text');

      // Validaciones
      if (!form.holder_name.value.length > 0) {
         // Valida el nombre del tarjetahabiente
         form.holder_name.classList.remove('input-text');
         form.holder_name.classList.add('input-error');
      } else if (
         !window.OpenPay.card.validateCardNumber(form.card_number.value)
      ) {
         // Valida el numero de tarjeta
         form.card_number.classList.remove('input-text');
         form.card_number.classList.add('input-error');
      } else if (
         !window.OpenPay.card.validateCVC(
            form.cvc.value,
            form.card_number.value
         )
      ) {
         // Valida el codigo de seguridad
         form.cvc.classList.remove('input-text');
         form.cvc.classList.add('input-error');
      } else if (
         !window.OpenPay.card.validateExpiry(form.month.value, form.year.value)
      ) {
         // Valida la fecha de vnecimiento
         form.month.classList.remove('input-text');
         form.year.classList.remove('input-text');
         form.month.classList.add('input-error');
         form.year.classList.add('input-error');
      } else {
         window.OpenPay.token.extractFormAndCreate(
            form,
            this.SUCCESS_CALLBACK.bind(this),
            this.ERROR_CALLBACK.bind(this)
         );
      }
   }

   // funcion donde se asigna el token
   SUCCESS_CALLBACK(response) {
      const dataPayment = {
         token_id: response.data.id,
         deviceSessionId: this.state.deviceSessionId,
         customer: this.state.customer,
         amount: this.props.subtotal,
         order_id: this.state.pedido,
         cart: this.props.carrito,
      };
      this.sendPay(dataPayment);
   }

   // funcion de error
   ERROR_CALLBACK(response) {
      console.log('error: ', response);
   }

   // Enviar Pago
   async sendPay(data) {
      console.log(data);
      this.setState({ pay_loading: true });
      document.getElementById('pay-button').disabled = true;
      const pago = await action.enviarPago(data);

      console.log(pago);
      if (pago) {
         if (pago.redirect) {
            this.props.dispatch({ type: 'CLEAN_CART' });
            window.location = pago.redirect;
         }
      } else {
         this.setState({ pay_loading: false });
         document.getElementById('pay-button').disabled = false;
      }
   }

   renderPay() {
      return (
         <div className="column justify-center hidden" id="renderPay">
            <div className="justify-end hidden" id="renderPay_message">
               <label className="color-red weight-medium">
                  {this.state.message}
               </label>
            </div>
            <div className="column pay justify-center" id="renderPay">
               <form
                  id="renderPay_form"
                  className="flex column"
                  onSubmit={this.pagar.bind(this)}
               >
                  <div className="row-responsive">
                     {/*<div className="column transacciones">
								<h5>Transacciones vía:</h5>
								<div className="white-space-8"></div>
								<div className="oimage responsive-img justify-center">
									<img src={openpaylogo} alt="OpenPay" />
								</div>
							</div>*/}
                     <div className="column aceptamos">
                        <div className="row">
                           <div className="column">
                              <h5>Aceptamos:</h5>
                              <div className="white-space-8"></div>
                              <div className="oimage responsive-img justify-center">
                                 <img src={visalogo} alt="Visa" />
                              </div>
                           </div>
                           <div className="column">
                              <div className="white-space-32"></div>
                              <div className="oimage responsive-img justify-center">
                                 <img src={mastercardlogo} alt="Master Card" />
                              </div>
                           </div>
                           <div className="column">
                              <div className="white-space-32"></div>
                              <div className="oimage responsive-img justify-center">
                                 <img src={americanlogo} alt="Master Card" />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <input
                     type="hidden"
                     name="token_id"
                     id="token_id"
                     size="50"
                  />
                  <div className="row-responsive">
                     <div className="column">
                        <h5>Nombre Tarjeta</h5>
                        <div className="white-space-8"></div>
                        <input
                           className="input-text"
                           name="holder_name"
                           data-openpay-card="holder_name"
                           required
                        />
                        <div className="white-space-16" />
                     </div>
                  </div>
                  <div className="row-responsive">
                     <div className="column">
                        <h5>Número de Tarjeta</h5>
                        <div className="white-space-8"></div>
                        <div className="input-card">
                           {this.state.cardIcon}
                           <input
                              className="input-text card-input"
                              name="card_number"
                              data-openpay-card="card_number"
                              placeholder="XXXX XXXX XXXX XXXX"
                              maxLength="16"
                              onChange={this.cardChange.bind(this)}
                              type="text"
                              required
                           />
                        </div>
                        <div className="white-space-16"></div>
                     </div>
                  </div>
                  <div className="row row-responsive">
                     <div className="column">
                        <div className="row-responsive">
                           <div className="column">
                              <h5>Fecha de Vencimiento</h5>
                              <div className="white-space-8"></div>
                              <input
                                 className="input-text"
                                 name="month"
                                 placeholder="MM"
                                 data-openpay-card="expiration_month"
                                 maxLength="2"
                                 type="text"
                                 required
                              />
                              <div className="white-space-8"></div>
                           </div>
                           <div className="column aa">
                              <div className="white-space-16" />
                              <div className="white-space-8"></div>

                              <input
                                 className="input-text"
                                 name="year"
                                 placeholder="AA"
                                 data-openpay-card="expiration_year"
                                 maxLength="2"
                                 type="text"
                                 required
                              />
                              <div className="white-space-8"></div>
                           </div>
                        </div>
                     </div>
                     <div className="column cvv">
                        <h5>Código Seguridad</h5>
                        <div className="white-space-8"></div>
                        <input
                           className="input-text"
                           name="cvc"
                           data-openpay-card="cvv2"
                           placeholder="CVV"
                           maxLength="4"
                           type="text"
                           required
                        />
                        <div className="white-space-8"></div>
                     </div>
                  </div>
                  <div className="white-space-16" />
                  <div className="row justify-center align-center">
                     <label htmlFor="terminos">
                        {' '}
                        <input
                           type="radio"
                           id="terminos"
                           required
                        /> Acepto{' '}
                        <a
                           href="/politicas"
                           target="_blank"
                           className="underline"
                        >
                           términos y condiciones de compra.
                        </a>{' '}
                     </label>
                  </div>
                  <div className="white-space-24" />
                  <div className="row justify-center align-center">
                     <button
                        type="submit"
                        id="pay-button"
                        className="btn btn-red color-white btn-pay"
                     >
                        PAGAR &nbsp;
                        {this.state.pay_loading ? (
                           <i className="fas fa-spinner fa-spin"></i>
                        ) : null}
                     </button>
                  </div>
               </form>
               <div className="white-space-16" />
               <div id="pay_form_message" className="justify-center">
                  <h5>{this.state.payMessage}</h5>
               </div>
               <div className="white-space-8" />
               <div id="renderPay_btns" className="justify-center hidden">
                  <button
                     className="btn btn-red color-white"
                     disabled={this.state.loading}
                     type="button"
                     onClick={() => {
                        document
                           .getElementById('renderPay')
                           .classList.add('hidden');
                        document
                           .getElementById('renderPay_btns')
                           .classList.add('hidden');
                        document
                           .getElementById('renderDirection')
                           .classList.remove('hidden');
                        document
                           .getElementById('modal-solicitar-pedido')
                           .classList.add('hidden');
                     }}
                  >
                     CERRAR
                  </button>
               </div>
            </div>
         </div>
      );
   }

   renderDirection() {
      return (
         <div className="justify-center" id="renderDirection">
            <form className="flex column" onSubmit={this.handleAdd.bind(this)}>
               <div className="row-responsive">
                  <div className="column">
                     <div className="white-space-8" />
                     <h5 className="color-white">Nombre</h5>
                     <div className="white-space-8" />
                     <input
                        className="input-text"
                        type="text"
                        name="name"
                        id="name"
                        required
                     />
                  </div>
                  <div className="column">
                     <div className="white-space-8" />
                     <h5 className="color-white">Apellido</h5>
                     <div className="white-space-8" />
                     <input
                        className="input-text"
                        type="text"
                        name="last_name"
                        id="last_name"
                        required
                     />
                  </div>
               </div>
               <div className="row-responsive">
                  <div className="column">
                     <div className="white-space-8" />
                     <h5 className="color-white">Domicilio</h5>
                     <div className="white-space-8" />
                     <input
                        className="input-text"
                        type="text"
                        name="address"
                        id="address"
                        required
                     />
                  </div>
               </div>

               <div className="row-responsive">
                  <div className="column">
                     <div className="white-space-8" />
                     <h5 className="color-white">Ciudad</h5>
                     <div className="white-space-8" />
                     <input
                        className="input-text"
                        type="text"
                        name="city"
                        id="city"
                        required
                     />
                  </div>
                  <div className="column zip">
                     <div className="white-space-8" />
                     <h5 className="color-white">Código postal</h5>
                     <div className="white-space-8" />
                     <input
                        className="input-text "
                        type="text"
                        name="zip"
                        id="zip"
                        required
                     />
                  </div>
                  <div className="column">
                     <div className="white-space-8" />
                     <h5 className="color-white">Estado</h5>
                     <div className="white-space-8" />
                     <select className="input-select" name="state">
                        <option value="1">Aguascalientes</option>
                        <option value="2">Baja California</option>
                        <option value="3">Baja California Sur</option>
                        <option value="4">Campeche</option>
                        <option value="5">Coahuila de Zaragoza</option>
                        <option value="6">Colima</option>
                        <option value="7">Chiapas</option>
                        <option value="8">Chihuahua</option>
                        <option value="9">Distrito Federal</option>
                        <option value="10">Durango</option>
                        <option value="11">Guanajuato</option>
                        <option value="12">Guerrero</option>
                        <option value="13">Hidalgo</option>
                        <option value="14">Jalisco</option>
                        <option value="15">México</option>
                        <option value="16">Michoacán</option>
                        <option value="17">Morelos</option>
                        <option value="18">Nayarit</option>
                        <option value="19">Nuevo León</option>
                        <option value="20">Oaxaca</option>
                        <option value="21">Puebla</option>
                        <option value="22">Querétaro</option>
                        <option value="23">Quintana Roo</option>
                        <option value="24">San Luis Potosí</option>
                        <option value="25">Sinaloa</option>
                        <option value="26">Sonora</option>
                        <option value="27">Tabasco</option>
                        <option value="28">Tamaulipas</option>
                        <option value="29">Tlaxcala</option>
                        <option value="30">Veracruz</option>
                        <option value="31">Yucatán</option>
                        <option value="32">Zacatecas</option>
                     </select>
                  </div>
               </div>
               <div className="row-responsive">
                  <div className="column">
                     <div className="white-space-8" />
                     <h5 className="color-white">Teléfono</h5>
                     <div className="white-space-8" />
                     <input
                        className="input-text"
                        type="text"
                        name="phone"
                        id="phone"
                        required
                     />
                  </div>
                  <div className="column">
                     <div className="white-space-8" />
                     <h5 className="color-white">Correo</h5>
                     <div className="white-space-8" />
                     <input
                        className="input-text"
                        type="email"
                        name="email"
                        id="email"
                        required
                     />
                  </div>
               </div>
               <div className="white-space-16" />
               <div className="justify-end">
                  <Button type="submit" disabled={this.state.loading}>
                     {this.state.loading ? (
                        <i
                           className="fas fa-spinner fa-spin"
                           style={{ fontSize: 18 }}
                        ></i>
                     ) : (
                        'Continuar'
                     )}
                  </Button>
               </div>
               <div className="white-space-8" />
            </form>
         </div>
      );
   }

   close() {
      const modal = document.getElementById('modal-solicitar-pedido');
      modal.classList.add('hidden');
      document.getElementById('terminos').checked = false;
      document.getElementById('renderDirection').classList.remove('hidden');
      document.getElementById('renderPay').classList.add('hidden');
      document.getElementById('renderPay_message').classList.add('hidden');
      document.getElementById('renderPay_form').classList.add('hidden');
   }

   render() {
      return (
         <div className="column">
            <div className="column modal-header">
               <div className="white-space-16"></div>
               <div className="row">
                  <div className="justify-center align-center">
                     <h3 className="color-white quicksand text-center">
                        Solicitar pedido
                     </h3>
                  </div>
               </div>
               <div className="white-space-16"></div>
            </div>
            {this.renderDirection()}
            {this.renderPay()}
         </div>
      );
   }
}
//Define las propiedades a obtener desde el store
function mapStateToProps(state) {
   return {
      auth: state.auth,
      user: state.user,
      login_error: state.login_error,
      checkout_loading: state.checkout_loading,
      checkout_status: state.checkout_status,
      checkout_items: state.checkout_items,
      carrito: state.carrito,
      subtotal: state.subtotal,
      num_pedido: state.num_pedido,
   };
}

export default connect(mapStateToProps)(ModalSolicitarPedido);



// WEBPACK FOOTER //
// ./src/components/Modals/solicitarpedido.js